import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { request } from "@/js/http/http_request";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import { wineNaming } from "@/js/wine/wine.js";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import { paymentStates } from "@/js/lists.ts";
import confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "AccountancyOrderReconciliationDialog",
  components: {
    confirm: confirm,
    ErrorModal: ErrorModal
  },
  props: {
    ocOrder: Object
  },
  data: function data() {
    return {
      dialog: false,
      tab: null,
      firstLoaded: false,
      isLoadingAssociations: false,
      associations: [],
      sumUpInvoices: {
        tableHeaders: [{
          text: "#EC",
          value: "invoiceNumberLabel",
          align: "left"
        }, {
          text: "Order",
          value: "orderData",
          align: "left",
          sortable: false
        }, {
          text: "Amount",
          value: "totalAmountCurrencyIncludeShipping",
          align: "center"
        }, {
          text: "Payment references",
          value: "oldPaymentReferences",
          align: "left"
        }]
      },
      addingForms: [],
      addingExternalForms: [],
      updatingForms: [],
      updatingExternalForms: [],
      quantityToggleKey: false,
      isAdding: [],
      isAddingExternal: [],
      isUpdating: [],
      isUpdatingExternal: [],
      isDeleting: [],
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    associationsByOcItemId: function associationsByOcItemId() {
      var _this$associations,
        _this2 = this;
      if (((_this$associations = this.associations) === null || _this$associations === void 0 ? void 0 : _this$associations.length) < 1) return [];
      var ocItemIds = _toConsumableArray(new Set(this.associations.map(function (x) {
        return x.ocItemData.id;
      })));
      var result = ocItemIds.map(function (id) {
        return {
          ocItemId: id,
          associations: _this2.associations.filter(function (x) {
            return x.ocItemData.id === id;
          })
        };
      });
      return result;
    },
    associationsByEcOrderId: function associationsByEcOrderId() {
      var _this$associations2;
      if (((_this$associations2 = this.associations) === null || _this$associations2 === void 0 ? void 0 : _this$associations2.length) < 1) return [];
      var associationsWithEc = this.associations.filter(function (x) {
        return !x.isExternalEcAssociation;
      });
      var associationsWithExternalEc = this.associations.filter(function (x) {
        return x.isExternalEcAssociation;
      });
      var resultWithEc = [];
      if (associationsWithEc.length > 0) {
        var orderIds = _toConsumableArray(new Set(associationsWithEc.map(function (x) {
          return x.ecItemData.orderId;
        })));
        resultWithEc = orderIds === null || orderIds === void 0 ? void 0 : orderIds.map(function (id) {
          var associations = associationsWithEc.filter(function (x) {
            return x.ecItemData.orderId === id;
          });
          var payments = [];
          var oldPaymentReferences = [];
          associations.forEach(function (x) {
            var _x$payment;
            if (((_x$payment = x.payment) === null || _x$payment === void 0 ? void 0 : _x$payment.id) > 0) {
              var paymentAmount = x.ocItemData.itemTotalAmountCurrencyIncludeShipping;
              var payment = payments.find(function (pr) {
                var _x$payment2;
                return pr.id === ((_x$payment2 = x.payment) === null || _x$payment2 === void 0 ? void 0 : _x$payment2.id);
              });
              if (payment) {
                payment.sumAmount += paymentAmount;
              } else {
                payments.push({
                  id: x.payment.id,
                  reference: x.payment.reference,
                  sumAmount: paymentAmount
                });
              }
            } else {
              x.oldPaymentReferences.forEach(function (pr) {
                if (!oldPaymentReferences.includes(pr)) {
                  oldPaymentReferences.push(pr);
                }
              });
            }
          });
          return {
            orderId: id,
            isExternalEcAssociation: false,
            invoiceNumberLabel: associations[0].ecItemData.orderInvoiceNumberLabel,
            orderAccountancyCode: associations[0].ecItemData.orderAccountancyCode,
            totalAmountCurrencyIncludeShipping: associations.reduce(function (acc, item) {
              return acc + item.ocItemData.itemTotalAmountCurrencyIncludeShipping;
            }, 0),
            currency: associations[0].ocItemData.currency,
            referenceLabel: associations[0].ecItemData.orderReferenceLabel,
            customerDisplayName: associations[0].ecItemData.orderCustomerDisplayName,
            payments: payments,
            oldPaymentReferences: oldPaymentReferences.length > 0 ? "".concat(oldPaymentReferences.join(" , "), " - previous version") : ""
          };
        });
      }
      var resultWithExternalEc = [];
      if (associationsWithExternalEc.length > 0) {
        var externalOrderIds = _toConsumableArray(new Set(associationsWithExternalEc.map(function (x) {
          return x.externalEcItemData.invoiceReference;
        })));
        resultWithExternalEc = externalOrderIds === null || externalOrderIds === void 0 ? void 0 : externalOrderIds.map(function (id) {
          var associations = associationsWithExternalEc.filter(function (x) {
            return x.externalEcItemData.invoiceReference === id;
          });
          var payments = [];
          var oldPaymentReferences = [];
          associations.forEach(function (x) {
            var _x$payment3;
            if (((_x$payment3 = x.payment) === null || _x$payment3 === void 0 ? void 0 : _x$payment3.id) > 0) {
              var paymentAmount = x.ocItemData.itemTotalAmountCurrencyIncludeShipping;
              var payment = payments.find(function (pr) {
                var _x$payment4;
                return pr.id === ((_x$payment4 = x.payment) === null || _x$payment4 === void 0 ? void 0 : _x$payment4.id);
              });
              if (payment) {
                payment.sumAmount += paymentAmount;
              } else {
                payments.push({
                  id: x.payment.id,
                  reference: x.payment.reference,
                  sumAmount: paymentAmount
                });
              }
            } else {
              x.oldPaymentReferences.forEach(function (pr) {
                if (!oldPaymentReferences.includes(pr)) {
                  oldPaymentReferences.push(pr);
                }
              });
            }
          });
          return {
            orderId: id,
            isExternalEcAssociation: true,
            invoiceNumberLabel: associations[0].externalEcItemData.invoiceReference,
            orderAccountancyCode: "",
            totalAmountCurrencyIncludeShipping: associations.reduce(function (acc, item) {
              return acc + item.ocItemData.itemTotalAmountCurrencyIncludeShipping;
            }, 0),
            currency: associations[0].ocItemData.currency,
            referenceLabel: "-",
            customerDisplayName: "-",
            payments: payments,
            oldPaymentReferences: oldPaymentReferences.length > 0 ? "".concat(oldPaymentReferences.join(" , "), " - previous version") : ""
          };
        });
      }
      return [].concat(_toConsumableArray(resultWithEc), _toConsumableArray(resultWithExternalEc));
    },
    ocPaymentsForSelector: function ocPaymentsForSelector() {
      var _this$ocOrder$payment,
        _this3 = this;
      if (((_this$ocOrder$payment = this.ocOrder.payments) === null || _this$ocOrder$payment === void 0 ? void 0 : _this$ocOrder$payment.length) > 0) {
        return this.ocOrder.payments.map(function (payment) {
          var _paymentStates$find, _payment$reference;
          var paymentStateLabel = ((_paymentStates$find = paymentStates.find(function (state) {
            return state.id === payment.state;
          })) === null || _paymentStates$find === void 0 ? void 0 : _paymentStates$find.name) || payment.state;
          var paymentDateFormatted = payment.paymentDate ? " - ".concat(_this3.$options.filters.formatDate(payment.paymentDate)) : "";
          return {
            id: payment.id,
            selectorDisplayName: "#".concat(((_payment$reference = payment.reference) === null || _payment$reference === void 0 ? void 0 : _payment$reference.length) > 0 ? payment.reference : "NoRef", " : ").concat(payment.amount, " ").concat(payment.currency, " by ").concat(payment.typeLabel, ", ").concat(paymentStateLabel).concat(paymentDateFormatted)
          };
        });
      } else {
        return [];
      }
    },
    isOrderOldStockTransfer: function isOrderOldStockTransfer() {
      var _this$ocOrder, _this$ocOrder2;
      return ((_this$ocOrder = this.ocOrder) === null || _this$ocOrder === void 0 ? void 0 : _this$ocOrder.isPreventInvoice) && ((_this$ocOrder2 = this.ocOrder) === null || _this$ocOrder2 === void 0 ? void 0 : _this$ocOrder2.is_destination_inbound);
    }
  },
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this4.getOrderReconciliations();
          case 2:
            _this4.firstLoaded = true;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getOrderReconciliations: function getOrderReconciliations() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this5.isLoadingAssociations = true;
              _this = _this5;
              _context2.next = 4;
              return request("/v1/accountancy/oc-ec-item-associations/oc-order/".concat(_this5.ocOrder.id_order), "get", null, true, "api").catch(function (e) {
                _this.isLoadingAssociations = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load existing associations");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context2.sent;
              _this5.associations = _toConsumableArray(response.data.value);
              _this5.isLoadingAssociations = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getAvailableReconciliationsForItem: function getAvailableReconciliationsForItem(itemId) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response, addingForm;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this6.addingForms = [].concat(_toConsumableArray(_this6.addingForms), [{
                ocItemId: itemId,
                ecItemId: null,
                nbBottlesAssociated: null,
                paymentId: null,
                isValid: false,
                isLoadingAvailableReconciliations: true,
                availableReconciliations: []
              }]);
              _this = _this6;
              _context3.next = 4;
              return request("/v1/accountancy/oc-ec-item-associations/oc-item/".concat(itemId, "/reconciliation-availables"), "get", null, true, "api").catch(function (e) {
                _this.closeAddingForm(itemId);
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load reconciliation availables");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context3.sent;
              addingForm = _this6.addingForms.find(function (x) {
                return x.ocItemId === itemId;
              });
              addingForm.availableReconciliations = _toConsumableArray(response.data.value);
              addingForm.isLoadingAvailableReconciliations = false;
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    saveAddingForm: function saveAddingForm(ocItemId) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var form, data, _this, index;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              form = _this7.addingForms.find(function (x) {
                return x.ocItemId === ocItemId;
              });
              _this7.isAdding.push(ocItemId);
              data = {
                ocItemId: form.ocItemId,
                ecItemId: form.ecItemId,
                nbBottlesAssociated: +form.nbBottlesAssociated,
                paymentId: form.paymentId
              };
              _this = _this7;
              _context4.next = 6;
              return request("/v1/accountancy/oc-ec-item-associations", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to create association", true);
                handleErrorData(_this, errorData);
                var index = _this.isAdding.indexOf(ocItemId);
                _this.isAdding.splice(index, 1);
                throw e;
              });
            case 6:
              index = _this.isAdding.indexOf(ocItemId);
              _this7.isAdding.splice(index, 1);
              _this7.closeAddingForm(ocItemId);
              _this7.getOrderReconciliations();
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    closeAddingForm: function closeAddingForm(ocItemId) {
      this.addingForms = this.addingForms.filter(function (x) {
        return x.ocItemId !== ocItemId;
      });
    },
    openExternalFormForItem: function openExternalFormForItem(itemId) {
      this.addingExternalForms = [].concat(_toConsumableArray(this.addingExternalForms), [{
        ocItemId: itemId,
        externalEcReference: "",
        nbBottlesAssociated: null,
        paymentId: null,
        isValid: false
      }]);
    },
    saveAddingExternalForm: function saveAddingExternalForm(ocItemId) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var form, data, _this, index;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              form = _this8.addingExternalForms.find(function (x) {
                return x.ocItemId === ocItemId;
              });
              _this8.isAddingExternal.push(ocItemId);
              data = {
                ocItemId: form.ocItemId,
                externalEcReference: form.externalEcReference,
                nbBottlesAssociated: +form.nbBottlesAssociated,
                paymentId: form.paymentId
              };
              _this = _this8;
              _context5.next = 6;
              return request("/v1/accountancy/oc-ec-item-associations/external", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to create association", true);
                handleErrorData(_this, errorData);
                var index = _this.isAddingExternal.indexOf(ocItemId);
                _this.isAddingExternal.splice(index, 1);
                throw e;
              });
            case 6:
              index = _this.isAddingExternal.indexOf(ocItemId);
              _this8.isAddingExternal.splice(index, 1);
              _this8.closeAddingExternalForm(ocItemId);
              _this8.getOrderReconciliations();
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    closeAddingExternalForm: function closeAddingExternalForm(ocItemId) {
      this.addingExternalForms = this.addingExternalForms.filter(function (x) {
        return x.ocItemId !== ocItemId;
      });
    },
    openUpdatingForm: function openUpdatingForm(associationId, ocItemId) {
      var _this$associations$fi;
      this.updatingForms = [].concat(_toConsumableArray(this.updatingForms), [{
        associationId: associationId,
        ocItemId: ocItemId,
        quantity: this.associations.find(function (x) {
          return x.id === associationId;
        }).nbBottlesAssociated,
        paymentId: (_this$associations$fi = this.associations.find(function (x) {
          return x.id === associationId;
        }).payment) === null || _this$associations$fi === void 0 ? void 0 : _this$associations$fi.id,
        isValid: false
      }]);
    },
    saveUpdatingForm: function saveUpdatingForm(associationId) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var form, data, _this, index;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              form = _this9.updatingForms.find(function (x) {
                return x.associationId === associationId;
              });
              _this9.isUpdating.push(associationId);
              data = {
                nbBottlesAssociated: +form.quantity,
                paymentId: form.paymentId
              };
              _this = _this9;
              _context6.next = 6;
              return request("/v1/accountancy/oc-ec-item-associations/".concat(associationId, "/quantity"), "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update association", true);
                handleErrorData(_this, errorData);
                var index = _this.isUpdating.indexOf(associationId);
                _this.isUpdating.splice(index, 1);
                throw e;
              });
            case 6:
              index = _this9.isUpdating.indexOf(associationId);
              _this9.isUpdating.splice(index, 1);
              _this9.closeUpdatingForm(associationId);
              _this9.getOrderReconciliations();
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    closeUpdatingForm: function closeUpdatingForm(associationId) {
      this.updatingForms = this.updatingForms.filter(function (x) {
        return x.associationId !== associationId;
      });
    },
    openUpdatingExternalForm: function openUpdatingExternalForm(associationId, ocItemId) {
      var _this$associations$fi2;
      this.updatingExternalForms = [].concat(_toConsumableArray(this.updatingExternalForms), [{
        associationId: associationId,
        ocItemId: ocItemId,
        externalEcReference: this.associations.find(function (x) {
          return x.id === associationId;
        }).externalEcItemData.invoiceReference,
        quantity: this.associations.find(function (x) {
          return x.id === associationId;
        }).nbBottlesAssociated,
        paymentId: (_this$associations$fi2 = this.associations.find(function (x) {
          return x.id === associationId;
        }).payment) === null || _this$associations$fi2 === void 0 ? void 0 : _this$associations$fi2.id,
        isValid: false
      }]);
    },
    saveUpdatingExternalForm: function saveUpdatingExternalForm(associationId) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var form, data, _this, index;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              form = _this10.updatingExternalForms.find(function (x) {
                return x.associationId === associationId;
              });
              _this10.isUpdatingExternal.push(associationId);
              data = {
                externalEcReference: form.externalEcReference,
                nbBottlesAssociated: +form.quantity,
                paymentId: form.paymentId
              };
              _this = _this10;
              _context7.next = 6;
              return request("/v1/accountancy/oc-ec-item-associations/external/".concat(associationId), "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update association", true);
                handleErrorData(_this, errorData);
                var index = _this10.isUpdatingExternal.indexOf(associationId);
                _this10.isUpdatingExternal.splice(index, 1);
                throw e;
              });
            case 6:
              index = _this.isUpdatingExternal.indexOf(associationId);
              _this10.isUpdatingExternal.splice(index, 1);
              _this10.closeUpdatingExternalForm(associationId);
              _this10.getOrderReconciliations();
            case 10:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    closeUpdatingExternalForm: function closeUpdatingExternalForm(associationId) {
      this.updatingExternalForms = this.updatingExternalForms.filter(function (x) {
        return x.associationId !== associationId;
      });
    },
    confirmDeleteAssociation: function confirmDeleteAssociation(associationId, ocItemId) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this11.$refs.confirm.open("Delete", "Are you sure you want to delete this association ?", {
                color: "red"
              });
            case 2:
              ok = _context8.sent;
              if (ok) _this11.deleteAssociation(associationId, ocItemId);
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    deleteAssociation: function deleteAssociation(associationId, ocItemId) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this12.isDeleting.push({
                associationId: associationId,
                ocItemId: ocItemId
              });
              _this = _this12;
              _context9.next = 4;
              return request("/v1/accountancy/oc-ec-item-associations/".concat(associationId), "delete", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update association", true);
                handleErrorData(_this, errorData);
                _this.isDeleting = _this.isDeleting.filter(function (x) {
                  return x.associationId !== associationId;
                });
                throw e;
              });
            case 4:
              _this12.isDeleting = _this.isDeleting.filter(function (x) {
                return x.associationId !== associationId;
              });
              _this12.getOrderReconciliations();
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    open: function open() {
      this.dialog = true;
    },
    close: function close() {
      this.dialog = false;
      this.$emit("closed");
    },
    orderDetails: function orderDetails(orderId) {
      var routeParams = {};
      return {
        name: "adminOrderSummary",
        params: {
          id: orderId,
          routeParams: routeParams
        }
      };
    },
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency,
    wineNaming: wineNaming,
    filterVAutocomplete: filterVAutocomplete,
    filterIntegerKey: filterIntegerKey
  }
};